export default "__VITE_ASSET__DFrZcAq2__"